import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { useRouter } from "next/router";
import type { ReactNode } from "react";
import React from "react";
import { Modal } from "~/components/common/parts/modal/Modal";
import { useCompanySettings } from "~/hooks/useCompanySettings";
import useItandiAccount from "~/hooks/useItandiAccount";
import type { CompanySettingWithStore } from "~/models/CompanySetting";
import type { CompanyStoreSetting } from "~/models/CompanyStoreSetting";
import { PATH as HOME_PATH } from "~/pages";
import Styles from "./CompanyStoreProxyLoginModal.module.scss";

type Props = DeepReadonly<{
	companySetting: CompanySettingWithStore;
	handleClose: () => void;
}>;

export const CompanyStoreProxyLoginModal: React.FC<Props> = ({
	companySetting,
	handleClose
}: Props) => {
	const router = useRouter();
	const { mutate } = useItandiAccount().currentAccount();
	const companySettingsApi = useCompanySettings();
	const onClickStore = React.useCallback(
		async (
			e: React.MouseEvent,
			companyStoreSetting: CompanyStoreSetting
		): Promise<void> => {
			e.preventDefault();
			await companySettingsApi.proxyLogin(
				companyStoreSetting.companyMasterId,
				companyStoreSetting.authId
			);
			await mutate();
			router.push(HOME_PATH).then();
		},
		[companySettingsApi, mutate, router]
	);
	const renderCompanyStore = React.useCallback(
		(companyStoreSetting: CompanyStoreSetting): ReactNode => (
			<div className={Styles.StoreRow} key={companyStoreSetting.authId}>
				<a
					className={Styles.StoreLink}
					href="#"
					onClick={(e: React.MouseEvent): void => {
						onClickStore(e, companyStoreSetting).then();
					}}
				>
					{companyStoreSetting.name}
					{companyStoreSetting.masterAccount ? (
						<span className={Styles.MasterLabel}>特権アカウント</span>
					) : null}
				</a>
			</div>
		),
		[onClickStore]
	);
	return (
		<Modal handleClose={handleClose} isOpen title="店舗に代理ログイン">
			<p className={Styles.Description}>
				代理ログインする店舗を選択してください
			</p>
			<div className={Styles.StoreList}>
				{companySetting.companyStoreSettings.map(renderCompanyStore)}
			</div>
		</Modal>
	);
};
